import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

const SECTIONS = [
  {
    heading: "What KnowYourPolicy.ai is (and isn't)",
    body: [
      "KnowYourPolicy.ai is an informational tool that explains motor insurance policy documents in plain language. We are not an insurer, insurance agent, broker, or advisor. We do not sell, recommend, or solicit any insurance product, and we earn no commission.",
    ],
  },
  {
    heading: "Nature of our analysis",
    body: [
      "Our analysis is automated and may contain errors or omissions. It is not legal, financial, or insurance advice. Coverage decisions rest solely with your insurer. Always verify anything important against your original policy wording and contact your insurer before making any claim or decision.",
    ],
  },
  {
    heading: "Privacy",
    body: [
      "You may upload a policy without an account. Uploaded documents and extracted data are stored securely and are visible only to you.",
      "Anonymous uploads not linked to an account are deleted after 30 days.",
      "You can request deletion of your data at any time.",
      "This is a private test build shared with a limited group.",
    ],
  },
  {
    heading: "Acceptance",
    body: ["By using this tool you accept these terms."],
  },
];

export default function Terms() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        path="/terms"
        title="Terms & Disclaimer"
        description="KnowYourPolicy.ai is an automated explainer for Indian motor insurance policies. Read our terms, privacy stance, and disclaimer — we explain policies, we never advise."
      />
      <Navbar />

      <article
        className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 md:pt-14 pb-16"
        data-testid="terms-page"
      >
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800"
          data-testid="terms-back"
        >
          <ArrowLeft className="h-4 w-4" />
          Back home
        </Link>

        <div className="mt-6 flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-blue-600 text-white flex items-center justify-center">
            <ShieldCheck className="h-5 w-5" strokeWidth={2.5} />
          </div>
          <h1
            className="font-display text-3xl md:text-4xl tracking-tight text-slate-900"
            data-testid="terms-title"
          >
            Terms &amp; Disclaimer
          </h1>
        </div>
        <p className="mt-3 text-sm text-slate-500">
          Last updated: February 2026
        </p>

        <div className="mt-10 space-y-10" data-testid="terms-content">
          {SECTIONS.map((s) => (
            <section key={s.heading} data-testid={`terms-section-${s.heading.replace(/\s+/g, "-").toLowerCase()}`}>
              <h2 className="font-display text-lg md:text-xl font-semibold text-slate-900">
                {s.heading}
              </h2>
              <div className="mt-3 space-y-3 text-slate-700 leading-relaxed">
                {s.body.map((p, i) => (
                  <p key={i} className="text-[15px]">
                    {p}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-14 border border-slate-200 bg-slate-50 rounded-2xl p-5 text-sm text-slate-600 leading-relaxed">
          Questions or a deletion request? Reach us via the support channel
          shared with you at the start of this test.
        </div>
      </article>

      <Footer />
    </div>
  );
}
